export default{
    "maintenance.title" : "Nous sommes désolés! Nous sommes présentement en maintenance, nous serons de retours dans quelques instants...",
}